<i18n>
{
    "en_US": {
        "upload": "Upload a file"
    },
    "fr_FR": {
        "upload": "Téléverser un fichier"
    }
}
</i18n>

<template>
    <div class="link-or-upload input-group mb-3 bmd-form-group">
        <input type="text" class="form-control bmb-control" v-bind:value="isLinkVisible ? value : value.name" v-on:input="update" v-bind:disabled="!isLinkVisible" />
        <div class="input-group-append">
            <span v-bind:class="{active: isLinkVisible}">
                <a class="btn btn-primary btn-upload" v-text="$t('upload')"></a>
            </span>
            <span v-bind:class="{active: !isLinkVisible}">
                <a v-on:click.stop.prevent="clearFileUpload" class="btn btn-primary btn-delete">
                    <i class="fas fa-times"></i>
                </a>
            </span>
        </div>
    </div>
</template>

<script>
    import { mapMutations } from "vuex";

    export default {
        name: "LinkOrUpload",
        props: ["value"],
        data: function() {
            return {
                uploader: null,
                saved: this.value
            };
        },
        computed: {
            isLinkVisible: function() {
                return typeof this.value === "string";
            }
        },
        methods: {
            removeAllButLatestFile: function() {
                const length = this.uploader.files.length;
                $.each(this.uploader.files, function(i, file) {
                    // Remove all but the latest one
                    if (i < length - 1) {
                        this.uploader.removeFile(file);
                    }
                }.bind(this));
            },
            clearFileUpload: function() {
                $.each(this.uploader.files, function(i, file) {
                    this.uploader.removeFile(file);
                }.bind(this));
                // We restore the previous search...
                this.$emit("input", this.saved);
            },
            update: function(e) {
                // We constantly save the current "string"
                // search, so if user delete the selected file,
                // we can go back to current string search
                this.$emit("input", e.target.value);
                this.saved = e.target.value;
            },
            ...mapMutations("flash", ["addFlash"])
        },
        mounted: function() {
            // This uploader only takes care of the popup to select
            // files. Another plupload instance will do the upload
            this.uploader = new plupload.Uploader({
                url: process.env.VUE_APP_BASE_URL + "/files/upload",
                multi_selection: false,
                browse_button: $(this.$el).find(".btn-upload")[0]
            });

            // Any error
            this.uploader.bind("Error", function(up, error) {
                this.addFlash({
                    type: "error",
                    message: error.message,
                    onlyCurrentRoute: true
                });
            }.bind(this));

            // Add files events
            this.uploader.bind("FilesAdded", function(up, file) {
                this.removeAllButLatestFile();
                // Adding the file
                for (var i = 0, l = file.length; i < l; i++) {
                    this.$emit("input", file[i]);
                }
            }.bind(this));

            this.uploader.init();
        },
        beforeDestroy: function() {
            this.uploader.destroy();
        }
    }
</script>

<style scoped>
    .link-or-upload {
        padding-top: 1rem;
        padding-bottom: 0.5rem;
    }
    .link-or-upload span {
        display: none;
    }
    .link-or-upload span.active {
        display: block;
    }
</style>
